export default "__VITE_ASSET__BSQ3Ih4U__"